import { useCallback, useMemo } from 'react';

import { validateApiResponse } from '../../../services';
import { getRole } from '../../../services/rolesService';
import { useAsyncLoad } from './useAsyncLoad';
import { mapApiRoleToUi } from './useRoles';

const errorKind = (err) => (err?.response?.status === 404 ? 'notFound' : 'failed');

/**
 * One role: `{ role, isLoading, error, setRole, refetch }`. `error` is `'notFound' | 'failed' | null`.
 * `setRole` swaps in the server's answer after an update without a second round trip.
 * Mount with `key={roleId}` so another role starts from the loading state.
 *
 * @param {string} roleId
 */
export const useRole = (roleId) => {
  const fetchRole = useCallback(
    () => getRole(roleId).then((res) => mapApiRoleToUi(validateApiResponse(res, 'Could not load the role').body)),
    [roleId],
  );
  const { data, isLoading, error, reload, setData } = useAsyncLoad(fetchRole, null, errorKind);

  return useMemo(() => ({ role: data, isLoading, error, setRole: setData, refetch: reload }), [data, isLoading, error, setData, reload]);
};
